import React from 'react';
import PropTypes from 'prop-types';
import _cloneDeep from 'lodash/cloneDeep';
import _isEqual from 'lodash/isEqual';

import Suggestions from '../../Suggestions';
import ChipsContainer from './ChipsContainer';

class ParentBrandsAdvancedSearch extends React.Component {
  static propTypes = {
    app: PropTypes.object.isRequired,
    parentBrands: PropTypes.array.isRequired,
    onParentBrandsChange: PropTypes.func.isRequired,
    autocompleteAppNameOverride: PropTypes.string
  };

  static defaultProps = {
    autocompleteAppNameOverride: null
  };

  componentWillMount() {
    this.updateParentBrands();
  }

  componentWillReceiveProps(nextProps) {
    if (!_isEqual(nextProps.parentBrands, this.props.parentBrands)) {
      this.updateParentBrands(nextProps);
    }
  }

  updateParentBrands = (nextProps) => {
    const { parentBrands } = nextProps || this.props;
    this.setState({ parentBrandChips: parentBrands.map((brand, index) => ({ key: index, i: brand.i, n: brand.n })) });
  };

  handleSelectionChange = (selection, index) => {
    const { parentBrandChips } = this.state;
    const clonedParentBrands = _cloneDeep(parentBrandChips);
    const isAlreadySelected = clonedParentBrands.filter((brand) => brand.value === selection.value).length > 0;
    if (index !== -1 && !isAlreadySelected) {
      clonedParentBrands.push({ key: clonedParentBrands.length, i: selection.id, n: selection.value });
      this.handleParentBrandsChange(clonedParentBrands);
    }
  };

  handleRequestDelete = (key) => {
    const { parentBrandChips } = this.state;
    const clonedBrands = _cloneDeep(parentBrandChips);
    const chipToDelete = clonedBrands.map((chip) => chip.key).indexOf(key);
    clonedBrands.splice(chipToDelete, 1);
    this.handleParentBrandsChange(clonedBrands);
  };

  handleParentBrandsChange = (parentBrands) => {
    const { onParentBrandsChange } = this.props;
    const values = parentBrands.map((parentBrand) => ({ i: parentBrand.i, n: parentBrand.n }));
    onParentBrandsChange({ key: 'parentBrandId', values });
  };

  render() {
    const { app, autocompleteAppNameOverride } = this.props;

    return (
      <div className="search-form-container">
        <h4 className="sl-form-label">Manufacturer</h4>
        <Suggestions
          autocompleteAppNameOverride={autocompleteAppNameOverride}
          apiUrl={`/api/${autocompleteAppNameOverride || app.apiAppName}/AutoCompleteSuggestions?term=`}
          className="sl-form-input"
          hintText="Refine by manufacturer"
          type="parentbrand"
          style={{ height: '48px' }}
          textFieldStyle={{ height: '48px' }}
          onSelectionChange={this.handleSelectionChange}
        />
        <ChipsContainer
          onDelete={(key) => this.handleRequestDelete(key)}
          chipData={this.state.parentBrandChips}
          dataKey="n"
        />
      </div>
    );
  }
}

export default ParentBrandsAdvancedSearch;
